import { useIsFocused, useNavigation } from '@react-navigation/native'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CSStackContext } from '../CSStackContext'
import { AppContext, CSService, ErrorHandling, Permission, TabView, TabViewInfo } from '@pulseops/common'
import { View } from 'react-native'
import { OPLSharedStyles } from '../../opl'
import { CSProcessGuidelineDocConst, CSProcessGuidelineDocContext } from '../cs-process-guideline-document'
import { pipe } from 'fp-ts/lib/function'
import { ZIO } from '@mxt/zio'
import { CSInternalProcessGuidelineDocList } from './CSInternalProcessGuidelineDocList'
import { CSInternalProcessGuidelineCreatingDoc } from './CSInternalProcessGuidelineCreatingDoc'

export const CSInternalProcessGuidelineDoc = () => {
  const { t } = useTranslation()
    const isFocused = useIsFocused()
    const rootNavigation = useNavigation()
    const [isActiveTabIndex, setIsActiveTabIndex] = React.useState(0)
    const { userPermissions } = React.useContext(CSStackContext)
    const { changeBreadcrumb } = React.useContext(AppContext.AppContextInstance)
    const getTabList = () => {
      const tabList: TabViewInfo[] = []
      if (userPermissions.includes(Permission.ViewInternalProcessGuidelineslist)) {
        tabList.push({
          tabName: t('OPL_CS:CS:List'),
          tabKey: 0
        })
      }
      if (userPermissions.includes(Permission.ViewInternalUploadProcessGuidelines)) {
        tabList.push({
          tabName: t('OPL_CS:CS:UploadDocument'),
          tabKey: 1
        })
      }
      return tabList
    }
  
    React.useEffect(() => {
      if (isFocused) {
        changeBreadcrumb([
          {
            title: '',
            navigate: () => {
              rootNavigation.navigate('HomeScreen')
            }
          },
          {
            title: t('menu:DocumentManagement'),
            navigate: () => rootNavigation.navigate('CSScreen')
          },
          {
            title: t('OPL_CS:CS:Internal_Process_Guidelines'),
            navigate: null
          }
        ])
      }
    }, [isFocused])
  
    const { docTypeList, docTypeDetailList } = pipe(
      CSService.getProcessDocTypeDetailList(),
      ZIO.map((response) => {
        return {
          docTypeList: response.body.docTypeList,
          docTypeDetailList: response.body.docTypeDetailList
        }
      }),
      ErrorHandling.runDidMount()
    ) || {
      docTypeList: [],
      docTypeDetailList: []
    }
  
    const getComponentByTabIndex = () => {
      switch (isActiveTabIndex) {
        case 0:
          return userPermissions.includes(Permission.ViewInternalProcessGuidelineslist) ? (
            <CSInternalProcessGuidelineDocList processType={CSProcessGuidelineDocConst.CSProcessGuidelineEnumType.CS_INTERNAL_GUIDANCE}></CSInternalProcessGuidelineDocList>
          ) : (
            <></>
          )
        case 1:
          return userPermissions.includes(Permission.ViewInternalUploadProcessGuidelines) ? (
            <CSInternalProcessGuidelineCreatingDoc processType={CSProcessGuidelineDocConst.CSProcessGuidelineEnumType.CS_INTERNAL_GUIDANCE} setIsActiveTabIndex={setIsActiveTabIndex}></CSInternalProcessGuidelineCreatingDoc>
          ) : (
            <></>
          )
        default:
          return <></>
      }
    }
    return (
      <CSProcessGuidelineDocContext.Provider value={{ docTypeList: docTypeList, docTypeDetailList: docTypeDetailList }}>
        <View style={OPLSharedStyles.wrapper}>
          <TabView
            isActiveTabIndex={isActiveTabIndex}
            setIsActiveTabIndex={setIsActiveTabIndex}
            data={getTabList()}
          ></TabView>
          {getComponentByTabIndex()}
        </View>
      </CSProcessGuidelineDocContext.Provider>
    )
}